__webpack_require__.p = "/barandbench/assets/";